import axios from "../../../../utils/axiosInceptor";
import {
    paymentProcessService,
    getpaymentLinkService
} from "../../../../configs/constants";


export const getPaymentLink = (payload) => {
    return axios.get(`${paymentProcessService}/${payload?.leaseId}/${payload?.userId}`);
};

export const getPaymentLinkNow = (payload) => {
    return axios.get(`${getpaymentLinkService}/${payload?.leaseId}/${payload?.userId}`);
};